// AI Requirements REST client.
//
// Previously BASE was "" so requests went to /demands/... (not served) and the
// catch block returned canned replies like "Consider security and observability
// baselines." — which read as a working AI agent. Now on the shared client.

import { get, post, demandPath, AI_TIMEOUT_MS } from "../../../api/http";

/**
 * Load the most recently saved spec.
 *
 * The builder had no way to reload previous work: it mounted with empty FR/NFR
 * tables every time, so reopening the screen silently discarded whatever had been
 * saved. Returns version 0 with empty collections when nothing is saved yet.
 */
export async function getRequirements(demandId) {
  return get(demandPath(demandId, "/requirements"));
}

/** Ask the requirements agent. -> { reply, fr, nfr, suggestions } */
export async function runRequirementsAI(demandId, message, chat = []) {
  return post(
    demandPath(demandId, "/requirements/generate"),
    { message, chat },
    { timeout: AI_TIMEOUT_MS }
  );
}

/** Persist a spec version. -> { version, completenessScore } */
export async function saveRequirementsArtifacts(demandId, files) {
  return post(demandPath(demandId, "/requirements/artifacts"), files);
}
